// extracted by mini-css-extract-plugin
export default {"root":"FA3H8","selected":"HWpJA","icon":"_6dHC","label":"mgjEa","content":"E3G_Q","contentFavourite":"gLgE1","bar":"Mx64R","highlightedBar":"fzEmI"};